import React, { Fragment } from 'react'
import Component from 'components/component'

import { DI } from 'modules'
import { Link } from 'components/link'

import { myContent } from 'config/routes'
import LinkA from './link-a'
import { IS_LANDING, ruLocaleOnly } from '../../config'

export function HeaderMobileMenu(props) {
  const { strings } = props.common
  const { isSignedIn } = props.user
  const user = props.user.currentUser.payload

  const toggleMobileMenu = ev => {
    props.actions.common.toggleMobileMenu()
  }

  const handleToggleInternationalMix = ev => {
    ev.preventDefault()
    ev.stopPropagation()
    props.onToggleInternationalMix(ev)
  }

  const signOut = ev => {
    ev.preventDefault()
    props.actions.user.signOut()
  }

  return (
    <div
      className="header-mm header-mm--new"
      style={props.common.mobileMenuOpen ? { display: 'block' } : {}}
    >
      <ul className="header-mm-list header-mm-list--new" onClick={toggleMobileMenu}>
        {isSignedIn &&
          <li className="header-mm-item header-mm-item--new">
            <Link to={myContent.getPath()} className="header-mm__link header-mm__link--new header-mm__link--new--mobile">
              {strings['header.menu.profile.myaccount']}
              <span className="header-mm__subtext">
                  {user.email}
                </span>
            </Link>
          </li>}
        {props.menu.mainMenu
          .filter(subitem => subitem.title)
          .map(item => (
            <li key={item.link} className="header-mm-item header-mm-item--new">
              <LinkA
                link={item.link}
                className={Component.classList(
                  'header-mm__link header-mm__link--new header-mm__link--new--mobile',
                  item.active && '_active'
                )}
              >
                {item.title}
              </LinkA>
            </li>
          ))}

        {props.showInternationalMixToggle && (
          <li className="header-mm-item header-mm-item--new header-mm-item--toggle">
            <button
              type="button"
              className={Component.classList(
                'header-mix-toggle header-mix-toggle--mobile',
                props.internationalMixActive && '_active'
              )}
              onClick={handleToggleInternationalMix}
              title={props.strings?.['mixed_content.tooltip']}
            >
                <span className="header-mix-toggle__track">
                  <span className="header-mix-toggle__thumb" />
                </span>
              <span className="header-mix-toggle__label">
                  {ruLocaleOnly
                    ? 'Англоязычные новости'
                    : 'Russian news feed'
                  }
                </span>
            </button>
          </li>
        )}

        {isSignedIn ? (
          <li className="header-mm-item header-mm-item--new">
            <a href="#" className="header-mm__link header-mm__link--new header-mm__link--new--mobile" onClick={signOut}>
              {strings['header.menu.profile.signout']}
            </a>
          </li>
        ) : (
          <Fragment>
            <li className="header-mm-item header-mm-item--new">
              <a
                href="#"
                className="header-mm__link header-mm__link--new header-mm__link--new--mobile"
                onClick={props.openSignInModal}
                data-action-name="header button"
              >
                {strings['header.profile.signin']}
              </a>
            </li>
            {IS_LANDING && <li className="header-mm-item header-mm-item--new">
              <a
                href="#"
                className="header-mm__link header-mm__link--new header-mm__link--new--mobile"
                onClick={props.openSignUpModal}
                data-action-name="header button"
              >
                {strings['header.profile.signup']}
              </a>
            </li>}
          </Fragment>
        )}
      </ul>
    </div>
  )
}

export default DI(['user', 'menu'])(HeaderMobileMenu)
